import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./SectionPage.module.css";
import { REACT_APP_API_URL } from "../../env";
import axios from "axios";

function SectionPage() {
  const { sectionKey } = useParams();
  const [pdfs, setPdfs] = useState([]);
  const [sectionTitle, setSectionTitle] = useState(sectionKey.toUpperCase());

  const isExplicitlyDisabled = (value) => {
    if (value === undefined || value === null || value === "") return false;
    if (typeof value === "boolean") return value === false;
    const normalized = String(value).trim().toLowerCase();
    return normalized === "0" || normalized === "false" || normalized === "off" || normalized === "no";
  };

  const formatMonthYear = (dateValue) => {
    if (!dateValue) return "";
    const parsed = new Date(dateValue);
    if (Number.isNaN(parsed.getTime())) return "";
    return parsed.toLocaleDateString("en-IN", {
      month: "long",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [mediaResponse, categoryResponse] = await Promise.all([
          axios.get(
            `${REACT_APP_API_URL}/api/dashboard/admin/list-all-media?type=${sectionKey}`
          ),
          axios.get(
            `${REACT_APP_API_URL}/api/dashboard/admin/media-categories`
          ),
        ]);

        const mediaList = (mediaResponse?.data?.data || []).filter(
          (item) =>
            !isExplicitlyDisabled(item.bitStatus) &&
            !isExplicitlyDisabled(item.bitShowOnWebsite) &&
            !isExplicitlyDisabled(item.bitCategoryStatus) &&
            !isExplicitlyDisabled(item.bitItemShowOnWebsite)
        );
        setPdfs(mediaList);

        const categories = (categoryResponse?.data?.data || []).filter(
          (item) => !isExplicitlyDisabled(item.showOnWebsite) && !isExplicitlyDisabled(item.bitStatus)
        );
        const matchedCategory = categories.find(
          (item) => String(item.categoryKey).toLowerCase() === String(sectionKey).toLowerCase()
        );
        setSectionTitle(
          matchedCategory?.title || String(sectionKey || "").toUpperCase()
        );
      } catch (err) {
        console.error("Error fetching PDFs:", err);
        setPdfs([]);
        setSectionTitle(String(sectionKey || "").toUpperCase());
      }
    };

    fetchData();
  }, [sectionKey]);

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerText}>{sectionTitle}</div>
      </div>

      <div
        className="row justify-content-center g-4"
        style={{
          margin: window.innerWidth <= 768
            ? "25px 12px 50px"
            : "40px 40px 60px",
        }}
      >
        {pdfs.map((pdf, index) => (
          <div
            key={pdf.intMediaId}
            className="col-12 col-sm-6 col-lg-4 col-xl-3"
          >
            <a
              href={`${REACT_APP_API_URL}/${pdf.vchFilePath.replace(/\\/g, "/")}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "block",
                height: "100%",
              }}
            >
              <div
                className="blog-item style-two"
                style={{
                  height: "80%",
                  minHeight: window.innerWidth <= 768 ? "auto" : "220px",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "18px",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                data-aos-duration={1500}
                data-aos-offset={50}
              >
                {/* IMAGE */}
                <div
                  className="image"
                  style={{
                    height: window.innerWidth <= 768 ? "220px" : "320px",
                    overflow: "hidden",
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: "18px",
                  }}
                >
                  {pdf.vchThumbnailPath && (
                    <img
                      src={`${REACT_APP_API_URL}/${pdf.vchThumbnailPath.replace(
                        /\\/g,
                        "/"
                      )}`}
                      alt={pdf.vchDescription}
                      style={{
                        width: "100%",
                        height: "200%",
                        objectFit: "fill",
                        transition: "0.5s ease",
                      }}
                    />
                  )}
                </div>

                {/* CONTENT */}
                <div
                  className="content"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    padding: window.innerWidth <= 768 ? "18px" : "16px",
                  }}
                >
                  {/* META
                  <ul
                    className="blog-meta"
                    style={{
                      flexWrap: "wrap",
                      rowGap: "4px",
                      marginBottom: "4px",
                    }}
                  >
                    <li>
                      <i className="far fa-calendar-alt" />{" "}
                      {formatMonthYear(pdf.dtmCreatedOn)}
                    </li>

                    <li>
                      <i className="far fa-file-pdf" /> PDF File
                    </li>
                  </ul> */}

                  {/* TITLE */}
                  <h5
                    title={pdf.vchDescription}
                    style={{
                      minHeight: "auto",
                      fontSize: window.innerWidth <= 768 ? "16px" : "17px",
                      lineHeight: "1.4",
                      color: "#333",
                      marginBottom: "4px",
                      fontWeight: "600",
                    }}
                  >
                    {pdf.vchDescription}
                  </h5>

                  {/* BUTTON TEXT */}
                  <span className="read-more">
                    View PDF <i className="fal fa-angle-right" />
                  </span>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>

    </div>
  );
}

export default SectionPage;
